import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface StatsSectionProps {
  stats: {
    icon: string;
    value: string;
    label: string;
  }[];
}

const StatsSection = ({ stats }: StatsSectionProps) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-card p-6 text-center hover:shadow-hover transition-shadow duration-300"
        >
          <div className="flex justify-center mb-3">
            <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center">
              <Icon
                name={stat.icon as any}
                size={24}
                variant="outline"
                className="text-accent"
              />
            </div>
          </div>
          <p className="text-3xl font-heading font-bold text-primary mb-1">
            {stat.value}
          </p>
          <p className="text-sm text-text-secondary">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;